import React from 'react';
import { Grid, Container } from '@mui/material';
import CapstoneSummary from '../components/_dashboard/capstone';
// components
import Page from '../components/Page';

const CapstoneOverview = () => {
  return (
    <Page title='Dashboard | Belong'>
      <Container maxWidth='xl'>
        <Grid item xs={12} sm={12} md={12}>
          <CapstoneSummary />
        </Grid>
      </Container>
    </Page>
  );
};

export default CapstoneOverview;
